import React, {useCallback} from 'react';

import {RoundButton} from '@optimaxdev/design-system';
import {connect} from 'react-redux';

import {CloudinaryImage} from 'components/cloudinaryImage/cloudinaryImage';
import {ApplicationStoreType} from 'desktop/store';

import {changeUhcAllowanceItem} from '../../store/reducers/applyingAllowance/applyingAllowance';
import {isUhcApplyingAllowance} from '../../store/selectors';

import DocumentIcon from './imgs/document.svg?url';
import GiftIcon from './imgs/gift.svg?url';

import s from './applyAllowanceTooltip.scss';

export type PropsType = {
    name: string;
    id: string;
    isLoading: boolean;
    applyAllowance: (id: string) => void;
    cancel: () => void;
};

/**
 * Form to change uhc allowance item on current cart item (with specific id)
 * @params {PropsType} data about cart item to apply allowance and callbacks
 * @returns {React.Element} form
 */
export const ApplyAllowanceTooltip: React.FC<PropsType> = ({
    applyAllowance: applyAllowanceAction,
    cancel,
    id,
    isLoading,
    name,
}) => {
    const applyAllowance = useCallback(() => {
        applyAllowanceAction(id);
    }, [applyAllowanceAction, id]);
    return (
        <div>
            <div className={s.greyArea}>
                <button className={s.close} onClick={cancel} type="button" />
                <p className={s.label}>Apply your allowance to {name}?</p>
                <div className={s.buttons}>
                    <RoundButton isLoading={isLoading} onClick={applyAllowance}>
                        Apply allowance
                    </RoundButton>
                    <button className={s.cancel} onClick={cancel} type="button">
                        Keep current discount
                    </button>
                </div>
            </div>
            <ul>
                <li className={s.listItem}>
                    <CloudinaryImage alt="document" src={DocumentIcon} />
                    <div>
                        <p className={s.title}>Plan Allowance</p>
                        <p>
                            Can be applied to only one
                            <br />
                            policy-covered item per order
                        </p>
                    </div>
                </li>
                <li className={s.listItem}>
                    <CloudinaryImage alt="gift" src={GiftIcon} />
                    <div>
                        <p className={s.title}>20% Exclusive Discount</p>
                        <p>
                            UHC members get special discount
                            <br />
                            on all other policy-covered items
                        </p>
                    </div>
                </li>
            </ul>
        </div>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
export const mapStateToProps = (store: ApplicationStoreType) => ({
    isLoading: isUhcApplyingAllowance(store),
});

export const ApplyAllowanceTooltipConnected = connect(mapStateToProps, {
    applyAllowance: changeUhcAllowanceItem,
})(ApplyAllowanceTooltip);
